export type FeatureKey =
  | 'Evaluation Strategy'
  | 'Domain'
  | 'Reasoning Mode'
  | 'Model'
  | 'System Prompt'
  | 'Result Analyzer'

export type KV = { key: string; value: any }

export type Entry = {
  path: string
  features: KV[]
  config?: KV[]
}

export type Catalog = {
  ignore?: string[]
  runs?: Entry[]
  artifacts?: Entry[]
}

export const FEATURE_ORDER: FeatureKey[] = [
  'Evaluation Strategy',
  'Domain',
  'Reasoning Mode',
  'Model',
  'System Prompt',
  'Result Analyzer',
]

export function featuresToMap(features: KV[]): Record<string, any> {
  const m: Record<string, any> = {}
  for (const kv of features || []) m[kv.key] = kv.value
  return m
}


